import TrainplanService from '@/services/TrainplanService'

export const get = () => TrainplanService.get('/1/migrated/plans')
